import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { PsychologicalHospitalizationsItemModel } from 'forms/sections/psychological/hospitalizations/types';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { hasYesOrNo } from 'models/validate';

const psychologicalHospitalizationItemValidator: ValidateJSModel<PsychologicalHospitalizationsItemModel> = {
  Admission: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }

    return {
      presence: true,
      hasValue: { validator: { inclusion: ['Voluntary', 'Involuntary'] } },
    };
  },

  Explanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { presence: true, hasValue: true };
  },

  TreatmentDate: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;

    return {
      presence: true,
      daterange: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },

  Facility: { presence: true, hasValue: true },

  FacilityAddress: (value, attributes, attributeName, options) => { //
    if (isPVQForm(options?.formType)) {
      return {
        presence: true, location: {
          requireStreet: true,
          validator: pvqLocationModelValidator
        }
      };
    }

    return {
      presence: true,
      location: { validator: locationAddressModelValidator, allowPOBox: false },
    };
  },

  Comments: {},
};

export default psychologicalHospitalizationItemValidator;
